import React, { useState, useEffect } from "react";
import { getActiveCandidate } from "../../../service/employerapi";
import { useNavigate } from "react-router-dom";
import { toast } from "react-toastify";

const ActiveCandidates = () => {
  const [industries, setIndustries] = useState([]);
  const [activeTab, setActiveTab] = useState("");

  useEffect(() => {
    const fetchIndustries = async () => {
      try {
        const res = await getActiveCandidate();
        if (res.data.status) {
          setIndustries(res.data.data);
          if (res.data.data.length > 0) {
            setActiveTab(res.data.data[0].industryTypeId);
          }
        }
      } catch (error) {
        console.error("Error fetching industries:", error);
      }
    };
    fetchIndustries();
  }, []);

  return (
    <section className="featuredjobs pt-50 pb-50">
      <div className="site-width">
        <div className="titleSection text-center">
          <h2>Skilled Talent Actively Seeking Work</h2>
          {/* <p>Find the right Candidate from Hourlee</p> */}
        </div>

        {/* Industry Tabs */}
        <nav className="joblistNav mb-3">
          <div className="nav nav-tabs" role="tablist">
            {industries.map((industry) => (
              <button
                key={industry.industryTypeId}
                className={`nav-link ${activeTab === industry.industryTypeId ? "active" : ""}`}
                onClick={() => setActiveTab(industry.industryTypeId)}
              >
                {industry.industryTypeName}
              </button>
            ))}
          </div>
        </nav>

        {/* Tab Content */}
        <div className="tab-content">
          {industries.map((industry) => (
            <div
              key={industry.industryTypeId}
              className={`tab-pane fade ${activeTab === industry.industryTypeId ? "show active" : ""}`}
            >
              <div className="listWrap">
                <div className="row">
                  {industry.jobSeekers.map((jobseeker) => (
                    <div key={jobseeker._id} className="col-md-4 mb-4">
                      <div className="astrocard">
                        <div className="astrocContainer">
                          <div className="astrohead">
                            <div className="astroImg">
                              <a href="#">
                                <img
                                  src={jobseeker.image || "/assets/img/logoSVG.svg"}
                                  alt="Profile"
                                />
                              </a>
                            </div>
                          </div>

                          <div className="astroDetails">
                            <div className="astroName">
                              <h4>{jobseeker.jobProfile}</h4>
                              <ul className="astroAcheiver companyName">
                                <li>
                                  <img src="/assets/img/icons/user-line-color.svg" width="20" alt="icon" />
                                  <p>{jobseeker.name}</p>
                                </li>
                              </ul>
                              <div className="astroinfo">
                                <li>
                                  <img src="/assets/img/icons/location-.svg" alt="icon" />
                                  <span>{jobseeker.city}, {jobseeker.state}</span>
                                </li>
                                <li>
                                  <img src="/assets/img/icons/calender.svg" alt="icon" />
                                  <span>Joined {jobseeker.profileCreated}</span>
                                </li>
                              </div>
                            </div>
                          </div>
                        </div>

                        <div className="astrolBtns flex-wrap">
                          {jobseeker.skills.map((skill, idx) => (
                            <a key={idx} href="#" className="astrocatbadge">{skill}</a>
                          ))}
                        </div>

                        <div className="d-flex gap-2 align-item-center w-100 joblistfooter">
                          <span className="joblistrate">
                            <img src="/assets/img/icons/time.svg" alt="img" style={{ width: "20px" }} />
                            ₹800/Day
                          </span>
                          <a href={`/employer/candidate/${jobseeker._id}`} className="mainbtn">View Details</a>
                        </div>
                      </div>
                    </div>
                  ))}
                </div>
              </div>
            </div>
          ))}
        </div>

        <div className="seeallbtnwrap text-center mt-4">
          <a href="/employer/candidate-list" className="outlineBtn">
            See More Candidates <i className="fa-solid fa-arrow-right"></i>
          </a>
        </div>
      </div>
    </section>
  );
};

export default ActiveCandidates;
